import { Button, Tag, Col, DatePicker, Divider, Dropdown, Form, Input, InputNumber, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { Link, useLoaderData, useNavigate, useOutletContext } from 'react-router-dom';
import EditableTable from '../../components/EditableTable';
import RowEditableTable from '../../../globalComponents/RowEditableTable';
import useInventoryAdjustmentAPI from '../../apis/inventoryAdjustmentAPI';
import { genUniqueNumbers } from '../../../utils/genUniqueID';
import AdjustmentReason from '../../modals/AdjustmentReasonModal';
import EventEmitter from '../../../utils/eventEmitter';
import { Pagination } from 'flowbite-react';
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { MdFilterAlt } from "react-icons/md";
import DebounceSelect from '../../components/DebounceSelect';
import Axios from '../../utils/axios';
import dayjs from 'dayjs';
import AuthContext from '../../../utils/AuthContext';
import useStockCountAPI from '../../apis/stockCountAPI';
import GoBack from '../../../globalComponents/GoBack';


const columns = [
  // {
  //   title: 'Location',
  //   dataIndex: 'location_id',
  //   key: 'location_id',
  //   editable: true,
  //   width: '15%',
  //   className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  // },
  {
    title: 'Product',
    dataIndex: 'product_id',
    key: 'product_id',
    editable: true,
    width: '15%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Package',
    dataIndex: 'package_id',
    key: 'package_id',
    editable: true,
    width: '15%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'On Hand',
    dataIndex: 'available_quantity',
    key: 'available_quantity',
    // editable: true,
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Counted Quantity',
    dataIndex: 'counted_quantity',
    key: 'counted_quantity',
    editable: true,
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  },
  {
    title: 'Difference',
    dataIndex: 'quantity_difference',
    key: 'quantity_difference',
    // editable: false,
    width: '10%',
    className: 'whitespace-nowrap font-medium dark:text-white',
    render: (_, record) => <span className={record.quantity_difference > 0 ? 'text-[#04c910]' : record.quantity_difference < 0 && 'text-red-600'}>{record.quantity_difference}</span>
  },
  // {
  //   title: 'User',
  //   dataIndex: 'user_id',
  //   key: 'user_id',
  //   editable: true,
  //   className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  // },
  {
    title: '',
    key: 'operation',
    editable: false,
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/inventory/inventory-adjustments'}>
        EDIT
      </Link>
    )
  }
]


// const items = [
//   {
//     key: 'To Do',
//     label: 'To Do',
//   },
//   {
//     key: 'Done',
//     label: 'Done',
//   },
//   {
//     type: 'divider'
//   },
//   {
//     key: 'Incoming',
//     label: 'Incoming'
//   },
//   {
//     key: 'Outgoing',
//     label: 'Outgoing'
//   }, 
//   {
//     key: 'Internal',
//     label: 'Internal'
//   }
// ];

const items = [
  {
    key: 'Internal',
    label: 'Internal'
  },
  {
    key: 'Transit',
    label: 'Transit'
  },
];


const StockCountInventory = () => {
  const stock = useLoaderData();
  const { user } = useContext(AuthContext);
  const [editingKey, setEditingKey] = useState('');
  const [adjustments, setAdjustments] = useState(stock);
  const { success, error } = useOutletContext();
  const { adjustCount } = useStockCountAPI();
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [searchItems, setSearchItems] = useState({});
  const navigate = useNavigate();
  

  const handleSave = async (record) => {
    try {
      let data = {...record};
      let adjustments_ = [...adjustments];
      let index = adjustments.findIndex(item => item.id === data.id);
      
      data['scheduled_date'] = new Date(data['scheduled_date']).toLocaleDateString();
      data.user_id = user.id;
      if (stock.length > 0) {
        const item = stock.find(prod => (prod.location_id === data.location_id) && (prod.product_id === data.product_id));
        // console.log(item);

        data['id'] = item.id;
        data['inventory_location'] = data.inventory_location;
      }
      adjustments_[index] = data;
      // console.log(data);
      await adjustCount(data, success);

      setTimeout(() => {
        setAdjustments(adjustments_);
      }, 500);
    }catch (err) {
      console.log(err);
    }
  }



  async function fetchUserList(username) {
    console.log('fetching user', username);
    return Axios(`products/search?query=${username}`)
      .then((response) => response.data)
      .then((res) =>
        res.map((product) => ({
          label: `${product.name}`,
          value: product.seo,
        })),
      );
  }

  return (
    <div>
      <div className='column mx-4 '><h3 className='font-bold'><GoBack /></h3></div>      
      <div className='dark:bg-gray-900 flex justify-end'>
        
        <div className='flex justify-end items-center overflow-x-auto'>
          <span className='text-sm me-2'>1-20 / 20</span>
          <Button type='text' size='small' icon={<IoIosArrowBack />} />
          <Button type='text' size='small' icon={<IoIosArrowForward />} />
        </div>
      </div>
      <RowEditableTable
        dataSource={searchItems.stock?.length > 0 ? searchItems.stock : adjustments}
        setDataSource={setAdjustments}
        columns={columns}
        apiSave={handleSave}
        handlenavigate={()=> {}}
        options={{products: [], locations: []}}
        // addLine={addLine}
        // option1={[]}
        // option2={[]}
        editingKey={editingKey}
        setEditingKey={setEditingKey}
        // options={{products: products, users: [], locations: locations}}
        // onClick={onClick}  
        triggers={[]}
        routes={[]}
      />
    </div>
  )
}

export default StockCountInventory;